@if(loading) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="messageLoader"></app-loader>
  </div>
}

<!-- Driver form dialog -->
<p-dialog [header]="isEditing ? 'Editar Conductor' : 'Nuevo Conductor'" [(visible)]="showFormDialog" [modal]="true" [style]="{width: '480px'}">
  <form [formGroup]="formDriver" class="space-y-4 pt-2">
    <!-- Avatar upload -->
    <div class="flex flex-col items-center gap-2 mb-2">
      <input type="file" class="hidden" (change)="onPhotoSelected($event)" #photoInput accept="image/png, image/jpeg" />
      @if(driverPhotoUrl) {
        <img [src]="driverPhotoUrl" class="w-20 h-20 rounded-full object-cover border-2 border-vivid-royal-200" />
      } @else {
        <app-avatar [name]="driverName.value || 'N'" size="lg" />
      }
      <button pButton label="Cambiar foto" icon="pi pi-camera" class="p-button-text p-button-sm"
        type="button" (click)="photoInput.click()"></button>
    </div>

    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Nombre del Conductor</label>
      <input pInputText formControlName="driverName" class="w-full mt-1" [patterns]="pattern" [validation]="false"
        [specialCharacters]="[' ']" [dropSpecialCharacters]="false" mask="K{20}" />
    </div>
    @if(driverName.errors?.['required'] && driverName.touched) {
      <small class="text-red-500">El nombre es requerido</small>
    }

    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Teléfono</label>
      <div class="flex gap-2 mt-1">
        <button pButton type="button" [label]="selectedLada" [icon]="'pi pi-chevron-down'" iconLayout="right"
          class="p-button-sm p-button-outlined w-28" [disabled]="phone.disabled || isEditing" (click)="toggleLadaList()"></button>
        <div class="relative flex-1">
          <input pInputText formControlName="phoneNumber" mask="(000) 000-0000"
            [specialCharacters]="[' ','(',')','-','.']" (keyup)="onInputPhone($event)"
            placeholder="(___) ___-____" class="w-full" autocomplete="off"
            [ngClass]="{'border-green-500': isPhoneAuth}" />
          @if(isPhoneAuth) {
            <i class="pi pi-check-circle text-green-500 absolute right-3 top-1/2 -translate-y-1/2"></i>
          }
        </div>
      </div>
      @if(showLadaList) {
        <div class="bg-white dark:bg-crayola-blue-800 border border-dark-khaki-200 dark:border-vivid-royal-700 rounded-lg shadow-lg mt-1 z-20 absolute w-64">
          <button type="button" class="w-full px-4 py-2 text-sm text-left hover:bg-dark-khaki-100 dark:hover:bg-vivid-royal-800 flex items-center gap-2" (click)="selectLada('+1')">
            <img src="./assets/icons/united-states-flag-icon.svg" class="h-4 w-5" /> United States (+1)
          </button>
          <button type="button" class="w-full px-4 py-2 text-sm text-left hover:bg-dark-khaki-100 dark:hover:bg-vivid-royal-800 flex items-center gap-2" (click)="selectLada('+52')">
            <img src="./assets/icons/mexico-flag-icon.svg" class="h-4 w-5" /> México (+52)
          </button>
        </div>
      }
    </div>
    @if(phone.errors?.['duplicate']) { <small class="text-red-500">Este teléfono ya está asignado</small> }
    @if(phone.errors?.['mask'] && phone.touched) { <small class="text-red-500">Se requieren 10 dígitos</small> }
    @if(showMessageError) { <small class="text-red-500">{{ messageError }}</small> }

    <!-- OTP inline -->
    @if(showOtpInput && !isPhoneAuth) {
      <div class="space-y-2 pt-2 border-t border-dark-khaki-200 dark:border-vivid-royal-700">
        <p class="text-xs text-vivid-royal-400">Código enviado al {{ selectedLada }} {{ phone.value }}</p>
        <div class="flex gap-2 items-center">
          <div class="flex gap-1">
            @for(i of [0,1,2,3]; track i) {
              <input pInputText type="text" maxlength="1" inputmode="numeric"
                [id]="'otp_'+i" class="w-11 h-11 text-center text-lg font-semibold"
                (keyup)="onOtpKeyUp($event, i)" (paste)="onOtpPaste($event)" />
            }
          </div>
          @if(otpError) { <small class="text-red-500">{{ otpError }}</small> }
        </div>
        <div class="flex items-center gap-2 text-xs">
          @if(otpTimer > 0) {
            <span class="text-vivid-royal-400">Reenviar en {{ otpTimer }}s</span>
          } @else {
            <button pButton label="Reenviar código" class="p-button-text p-button-sm" (click)="resendOtp()"></button>
          }
          @if(sendingOtp) { <i class="pi pi-spin pi-spinner text-vivid-royal-400"></i> }
        </div>
      </div>
    }
  </form>
  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="showFormDialog=false" [disabled]="saving"></button>
    <button pButton [label]="saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Agregar')"
      [icon]="saving ? 'pi pi-spin pi-spinner' : ''"
      [disabled]="formDriver.invalid || !isPhoneAuth || saving" (click)="addDriver()"></button>
  </ng-template>
</p-dialog>

<!-- Cropper dialog -->
<p-dialog header="Recortar imagen" [(visible)]="showCropper" [modal]="true" [style]="{width: '500px'}" [baseZIndex]="10000" appendTo="body">
  <image-cropper
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="1 / 1"
    format="png"
    output="base64"
    [autoCrop]="false"
    (imageCropped)="imageCropped($event)"
    class="w-full"
    #cropperRef
  ></image-cropper>
  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="showCropper=false"></button>
    <button pButton label="Recortar" icon="pi pi-check" (click)="doCrop(cropperRef)"></button>
  </ng-template>
</p-dialog>

<div class="p-6" *ngIf="!loading">

  <!-- Delete confirm dialog -->
  <p-dialog header="Confirmar eliminación" [(visible)]="showDeleteConfirm" [modal]="true" [style]="{width: '400px'}">
    <p class="text-sm">¿Desea eliminar al conductor <b>{{ deleteTarget?.name }}</b>?</p>
    <ng-template #footer>
      <button pButton label="Cancelar" class="p-button-text" (click)="showDeleteConfirm=false"></button>
      <button pButton label="Eliminar" class="p-button-danger" icon="pi pi-trash" (click)="deleteDriver()"></button>
    </ng-template>
  </p-dialog>

  <!-- Toolbar -->
  <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
    <p-iconfield>
      <p-inputicon styleClass="pi pi-search" />
      <input pInputText type="text" [(ngModel)]="globalFilter" placeholder="Buscar conductor..." class="w-72" />
    </p-iconfield>
    <div class="flex gap-2">
      @if(selectedDrivers.length > 0 && isAdmin) {
        <button pButton label="Eliminar seleccionados" icon="pi pi-trash" class="p-button-sm p-button-danger p-button-outlined" (click)="deleteSelected()"></button>
      }
      @if(isAdmin) {
        <button pButton label="Nuevo Conductor" icon="pi pi-plus" class="p-button-sm" (click)="openNew()"></button>
      }
    </div>
  </div>

  <!-- Desktop Table -->
  <div class="hidden md:block">
  <p-table [value]="drivers" [paginator]="drivers.length > 10" [rows]="10" [rowsPerPageOptions]="[10, 30, 50]"
    [globalFilterFields]="['name','phone_number']" styleClass="p-datatable-sm p-datatable-striped"
    [scrollable]="true" scrollHeight="flex"
    [showCurrentPageReport]="true" [currentPageReportTemplate]="'Mostrando {first} a {last} de {totalRecords}'">
    <ng-template #header>
      <tr>
        <th class="w-[50px]"></th>
        <th [pSortableColumn]="'name'">Nombre <p-sortIcon field="name" /></th>
        <th>Teléfono</th>
        <th [pSortableColumn]="'validFrom'">Activo desde <p-sortIcon field="validFrom" /></th>
        <th>Estado</th>
        @if(isAdmin) { <th class="w-[200px] text-center">Acciones</th> }
      </tr>
    </ng-template>
    <ng-template #body let-driver>
      <tr>
        <td>
          <app-avatar [name]="driver.name" size="sm" [photoUuid]="driver.photo_uuid || null" />
        </td>
        <td class="font-medium">{{ driver.name }}</td>
        <td>{{ driver.phone_number }}</td>
        <td>{{ driver.validFrom | date:'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <span class="px-2 py-1 rounded-full text-xs font-semibold"
            [ngClass]="isActive(driver) ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'">
            {{ isActive(driver) ? 'Activo' : 'Pendiente' }}
          </span>
        </td>
        @if(isAdmin) {
          <td class="text-center">
            <div class="flex justify-center gap-1">
              <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm" pTooltip="Editar" (click)="openEdit(driver)"></button>
              <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text p-button-sm" pTooltip="Eliminar" (click)="confirmDelete(driver)"></button>
              @if(!isActive(driver)) {
                <button pButton icon="pi pi-envelope" class="p-button-rounded p-button-text p-button-sm" pTooltip="Reenviar activación" (click)="resend(driver)"></button>
              }
            </div>
          </td>
        }
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr><td [attr.colspan]="isAdmin ? 6 : 5" class="text-center py-8 text-vivid-royal-400">No hay conductores registrados</td></tr>
    </ng-template>
  </p-table>
  </div>

  <!-- Mobile Cards -->
  <div class="md:hidden space-y-3">
    @if(drivers.length === 0) {
      <p class="text-center py-8 text-vivid-royal-400">No hay conductores registrados</p>
    }
    @for(driver of drivers; track driver.driver_id) {
      <div class="bg-white dark:bg-crayola-blue-800 rounded-lg shadow-sm p-4 space-y-2">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <app-avatar [name]="driver.name" size="sm" [photoUuid]="driver.photo_uuid || null" />
            <span class="font-bold text-vivid-royal-800 dark:text-white">{{ driver.name }}</span>
          </div>
          <span class="px-2 py-0.5 rounded-full text-xs font-semibold"
            [ngClass]="isActive(driver) ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'">
            {{ isActive(driver) ? 'Activo' : 'Pendiente' }}
          </span>
        </div>
        <div class="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
          <div class="text-vivid-royal-400">Teléfono</div>
          <div class="text-right text-vivid-royal-900 dark:text-white">{{ driver.phone_number }}</div>
          <div class="text-vivid-royal-400">Activo desde</div>
          <div class="text-right text-vivid-royal-900 dark:text-white">{{ driver.validFrom | date:'dd/MM/yyyy' }}</div>
        </div>
        @if(isAdmin) {
          <div class="flex gap-2 pt-2 border-t border-dark-khaki-200 dark:border-vivid-royal-700">
            <button pButton icon="pi pi-pencil" label="Editar" class="p-button-sm p-button-outlined flex-1" (click)="openEdit(driver)"></button>
            <button pButton icon="pi pi-trash" class="p-button-sm p-button-danger p-button-outlined" (click)="confirmDelete(driver)"></button>
            @if(!isActive(driver)) {
              <button pButton icon="pi pi-envelope" label="Reenviar" class="p-button-sm p-button-outlined flex-1" (click)="resend(driver)"></button>
            }
          </div>
        }
      </div>
    }
  </div>
</div>


